import feathersClient from '@/feathers-client'
import { getCategoryId } from '@/composables/utils'
import { calcCategoryGoalRatingAvg } from './calcCategoryGoalRatingAvg'
/**
 * Normalizes Feathers response to always be an array
 * @param {Array|Object} response - API response from Feathers
 * @returns {Array} Normalized array of items
 */
const normalizeResponse = (response) => {
  if (Array.isArray(response)) {
    return response
  }
  return response?.data || []
}

/**
 * THIS IS FOR LEGACY COMPASS VERSIONS USING THE OLD GOALS SYSTEM
 * @param {number} frameworkId - The ID of the framework
 * @param {string|number} compassId - The ID of the compass
 * @param {Array} categories - Array of category objects
 * @param {number} compassVersion - The version of the compass
 * @returns {Promise<Array<number>>} Array of category action ratings
 */
export const getCategoryGoalRatingsAvg = async (frameworkId, compassId, categories) => {
  // Validate required parameters
  if (!compassId || !frameworkId || !categories || categories.length === 0) {
    console.error('Invalid parameters for getCategoryGoalRatingsAvg')
    return categories.map(() => 0)
  }
  const goalsResponse = await feathersClient.service('compass-goals').find({
    query: {
      compassId,
    },
  })
  const goals = normalizeResponse(goalsResponse)
  return categories.map(category => {
    const categoryGoals = goals.filter(goal => getCategoryId(goal.subCategoryId) === category.id)
    return calcCategoryGoalRatingAvg(categoryGoals)
  })
}
